module.exports = __webpack_public_path__ + "img/CN_bilibili B.7d9d0eb6.png";